import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class BolloVirtualePRModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$uibModal',
        'configuration',
        '$sce'
    ];

    private close: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private configuration: any,
        private $sce: ng.ISCEService
    ) {

        $scope.bollo = $scope.$parent.$resolve.item === 'SI';
        $scope.save = () => {
            this.close({ $value: $scope.bollo });
        };
        $scope.cancel = () => {
            this.close();
        };
        $scope.popover1 = $sce.trustAsHtml(
            '<br/><br/>Flaggando Bollo virtuale comunichi al Destinatario che assolverai l\'obbligo di pagamento dell\'imposta di bolla entro 120 dalla chiusura del periodo di esercizio tramite F24 come previsto dal DMEF 17 Giugno 2014.<br/>' +
            '<br/>' +
            'Ti consigliamo di tenere un conteggio con la somma dei bolli applicati sulle tue Fatture Elettroniche.<br/>' +
            '<br/>' +
            'L\'imposta di bolla è obbligatoria sulle fatture non soggette ad IVA che superano l\'importo di € 77,47.<br/>' +
            'In questi casi, l\'imposta di bollo prevista è di € 2.<br/>' +
            '<br/>' +
            'Per ulteriori informazioni<br/>' +
            'http://www.agenziaentrate.gov.it/wps/content/Nsilib/ Nsi/Home/CosaDeviFare/Dichiarare/Pagamento+virtuale+imposta+bollo/  Informazioni+generali+pagvirtualebollo/<br/>');
    }
}

export const BolloVirtualePRModalComponent: ng.IComponentOptions = {
    template: require('./bollo-virtuale-pr-modal.html'),
    controller: BolloVirtualePRModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/bollo-virtuale-pr-modal/bollo-virtuale-pr-modal.ts